import { Switch } from '@mm/components';
import { Tooltip } from 'antd';
import React from 'react';
import styles from './EnrichButton.module.css';
import { useSelector } from 'react-redux';
import { selectIsShopifyContext } from '@mm/state/selectors/viewSelectors';

export const EnrichButton = () => {
  const isShopify = useSelector(selectIsShopifyContext);

  if (isShopify) {
    return null;
  }

  return (
    <div className={styles.container}>
      Enrich X-Ray Leads
      <Tooltip
        title="X-Ray leads contacts will be enriched with consumer
      information FREE for a limited time on your plan"
        placement="bottom"
      >
        <div className={styles.switch}>
          <Switch checked />
        </div>
      </Tooltip>
    </div>
  );
};
